import type { ComponentStyleConfig } from "@chakra-ui/theme";

export const Button: ComponentStyleConfig = {
	baseStyle: {
		fontWeight: 500,
		borderRadius: "5px",
		fontFamily: ["SF Pro", "Roboto"],
		padding: "12px",
	},
	sizes: {
		lg: {
			fontSize: {
				base: "sm",
				lg: "lg",
			},
		},
		md: {
			fontSize: {
				base: "sm",
				lg: "md",
			},
		},
		sm: {
			fontSize: {
				base: "xs",
				lg: "sm",
			},
		},
	},
	variants: {
		solid: (props) => ({
			bg: `${props.colorScheme}.500`,
			_disabled: { bg: `${props.colorScheme}.400`, pointerEvents: "none" },
			_hover: { bg: `${props.colorScheme}.600` },
			color: "white.500",
		}),
		outline: (props) => ({
			color: `${props.colorScheme}.500`,
			border: "2px solid",
			borderColor: `${props.colorScheme}.500`,
			_hover: "none",
			_focus: "none",
			_active: "none",
			_disabled: {
				pointerEvents: "none",
				color: `${props.colorScheme}.600`,
				border: "2px solid",
				borderColor: `${props.colorScheme}.600`,
			},
		}),
		ghost: (props) => ({
			color: `${props.colorScheme}.500`,
			_hover: "none",
			_focus: "none",
			_active: "none",
			_disabled: { pointerEvents: "none", color: `${props.colorScheme}.600` },
		}),
	},
	defaultProps: {
		size: "lg",
		variant: "solid",
		colorScheme: "purple",
	},
};
